import PropTypes from 'prop-types';
import GridOptions from './GridOptions';
import MuiGrid from '../../../UI/MuiGrid/MuiGrid';
import { icons } from '../../../../../shared/icons';
import { formatPrice } from '../../../../../utils/FormatPrice';
import { formatDateFromDB } from '../../../../../utils/FormatDate';
import { useTranslation } from 'react-i18next';

const GridProvider = ({
  data,
  handleOpenDeleteDialog,
  handleEditData,
  loading,
}) => {
  const { t, i18n } = useTranslation();
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: t('options'),
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDeleteDialog(e.id)}
          getEditData={() => handleEditData(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    { field: 'naziv', headerName: t('name'), width: 200 },

    {
      field: 'marza',
      headerName: t('marza'),
      width: 200,
      align: 'right',
      renderCell: (params) => (
        <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
          {formatPrice(params.value)}
        </span>
      ),
    },

    {
      field: 'vremeKreiranja',
      headerName: t('dateCreate'),

      width: 150,
      renderCell: (e) => formatDateFromDB(e.row.vremeKreiranja),
    },
  ];

  return (
    <div style={{ height: '75vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} loading={loading} />
    </div>
  );
};

GridProvider.propTypes = {
  data: PropTypes.array.isRequired,
  handleOpenDeleteDialog: PropTypes.func.isRequired,
  handleEditData: PropTypes.func.isRequired,
};

export default GridProvider;
